// ============================================================================
// MapBoundsFitter Component
// ============================================================================

import { useEffect } from "react";
import { useMap } from "@vis.gl/react-google-maps";
import type { MapBoundsFitterProps } from "./IssueMap.types";

/**
 * Sub-component that handles fitting the map bounds to the provided coordinates
 */
export function MapBoundsFitter({ coordinates }: MapBoundsFitterProps) {
	const map = useMap();

	useEffect(() => {
		if (!map || coordinates.length === 0) return;

		const bounds = new google.maps.LatLngBounds();
		coordinates.forEach((coord) => bounds.extend(coord));

		// Use idle listener to ensure map is ready
		const idleListener = google.maps.event.addListenerOnce(map, "idle", () => {
			map.fitBounds(bounds, { top: 50, right: 50, bottom: 50, left: 50 });
		});

		// Also try immediately in case map is already idle
		map.fitBounds(bounds, { top: 50, right: 50, bottom: 50, left: 50 });

		return () => {
			google.maps.event.removeListener(idleListener);
		};
	}, [map, coordinates]);

	return null;
}
